export default __webpack_public_path__ + "static/media/slider-smiles-2.e380c0ec.jpg";